import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';

import { MonetizationType } from '@/@types/graphql-types';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { useSpinningText } from '@/helpers/composables/useSpinningText';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'FlatAdsBuy',
  props: {
    title: null,
    offers: null,
    seasonNumber: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	offers: TitleDetail['offers'];
	seasonNumber?: number | undefined;
};

const { language } = storeToRefs(useLanguageStore());



const { getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock } = useSpinningText(toRefs(props));

const text = computed(() => {
	switch (language.value) {
		case 'fi':
			return [
				getInfoTextBlock(
					MonetizationType.Flatrate,
					'Tällä hetkellä voit katsoa elokuvan',
					'suoratoistona palvelussa'
				),
				getOfferTextBlock(MonetizationType.Ads, ' tai ilmaiseksi mainosten kanssa palvelussa'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Voit myös ostaa elokuvan', 'netissä palvelussa'),
				'. ',
			];
		case 'ru':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'В настоящее время Вы можете посмотреть', 'на'),
				getOfferTextBlock(MonetizationType.Ads, ' или бесплатно с рекламой на'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Также возможно купить и скачать', 'на'),
				'. ',
			];
		case 'it':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Adesso puoi guardare', 'in streaming su'),
				getOfferTextBlock(MonetizationType.Ads, ' o gratuitamente con avvisi pubblicitari su'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Puoi acquistare', 'scaricandolo da'),
				'. ',
			];
		case 'de':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Du kannst', 'im Abo bei'),
				getOfferTextBlock(
					MonetizationType.Ads,
					'oder bei',
					'kostenlos mit Werbeunterbrechungen im Stream anschauen'
				),
				'. ',
				getInfoTextBlock(
					MonetizationType.Buy,
					'Zusätzlich ist',
					'noch bei',
					'als Download zum Kaufen verfügbar'
				),
				'. ',
			];
		case 'pt':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Você pode assistir', 'com assinatura no'),
				getOfferTextBlock(MonetizationType.Ads, ' ou no', 'gratuitamente com comerciais nos intervalos'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, '', 'ainda está disponível no', 'para comprar o Download'),
				'. ',
			];
		case 'fr':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'En ce moment, vous pouvez regarder', 'en streaming sur'),
				getOfferTextBlock(MonetizationType.Ads, ' ou gratuit avec publicités sur'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Il est également possible d`acheter', 'en téléchargement sur'),
				'. ',
			];
		case 'es':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Actualmente, usted es capaz de ver', 'streaming en'),
				getOfferTextBlock(MonetizationType.Ads, ' o forma gratuita con anuncios en'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Por lo tanto, es posible comprarlo', 'como descarga en'),
				'. ',
			];
		// TODO JA
		case 'ko':
			return [
				getOfferTextBlock(
					MonetizationType.Flatrate,
					'현재 ',
					`에서 "${props.title}" 스트리밍 서비스 중입니다. `
				),
				getOfferTextBlock(MonetizationType.Ads, '광고가 포함된 영상은 ', '에서 무료 배포 중이며 '),
				getOfferTextBlock(MonetizationType.Buy, '', '에서 유료 다운로드하실 수 있습니다. '),
			];
		case 'ro':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'În prezent, puteți viziona', 'streaming pe'),
				getOfferTextBlock(MonetizationType.Ads, ' sau gratuit cu afișare de anunțuri pe'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Puteți, de asemenea, să cumpărați', 'prin descărcare on'),
				'. ',
			];
		case 'hu':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Jelenleg a(z)', 'adatfolyamként elérhető a(z)'),
				getOfferTextBlock(
					MonetizationType.Ads,
					' szolgáltatónál, vagy megtekinthető ingyenesen reklámokkal itt:'
				),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Továbbá a(z)', 'online megvásárolható itt:'),
				'. ',
			];
		case 'cs':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Aktuálně máte možnost sledovat', 'streaming u'),
				getOfferTextBlock(MonetizationType.Ads, 'nebo zdarma s reklamami u'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, ' Si můžete koupit', ' ke stažení u'),
				'. ',
			];
		case 'bg':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'В момента можете да гледате стрийминг на', 'в', 'онлайн'),
				getOfferTextBlock(MonetizationType.Ads, ' или безплатно с реклами в'),
				'. ',
				getInfoTextBlock(
					MonetizationType.Buy,
					'Възможно е също да купите',
					' да го купите като изтеглена версия в'
				),
				'. ',
			];
		case 'ar':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'يمكنكم حالياً مشاهدة', 'الذي يُبث على'),
				getOfferTextBlock(MonetizationType.Ads, ' أو مجاناً مع الإعلانات على'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'من الممكن أيضاً شراء', 'عبر تنزيله على'),
				'. ',
			];
		case 'pt':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Atualmente você pode assistir', 'em streaming via'),
				getOfferTextBlock(MonetizationType.Ads, ' ou gratuitamente com anúncios via'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Também é possível comprar', 'como download via'),
				'. ',
			];
		case 'tr':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Şu an', 'adlı yapımı', 'üzerinden veya'),
				getOfferTextBlock(MonetizationType.Ads, ' platformunda ücretsiz ama reklamlı olarak izleyebilirsiniz'),
				'. ',
				getInfoTextBlock(
					MonetizationType.Buy,
					'',
					'adlı yapımı satın',
					'üzerinden satın alarak indirebilirsiniz'
				),
				'. ',
			];
		case 'sq':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Aktualisht, ju mund të shikoni', 'në'),
				getOfferTextBlock(MonetizationType.Ads, ' apo falas me reklama në'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Gjithashtu është e mundur të blini', 'si shkarkim në'),
				'. ',
			];
		case 'pl':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Obecnie możesz oglądać', 'w streamingu w serwisie'),
				getOfferTextBlock(MonetizationType.Ads, ' lub za darmo z reklamami w serwisie'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Można również kupić', 'jako plik do pobrania w serwisie'),
				'. ',
			];
		case 'ro':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Acum poți să vezi', 'pe'),
				getOfferTextBlock(MonetizationType.Ads, ' sau gratuit, cu reclame, pe'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Poți de asemenea să cumperi și să descarci', 'pe'),
				'. ',
			];
		case 'az':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Hazırda siz', 'üzərindən'),
				getOfferTextBlock(
					MonetizationType.Ads,
					' yayımını',
					'üzərindən reklamlarla ödənişsiz izləyə bilərsiniz'
				),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Həmçinin', 'filmini', 'vasitəsilə alaraq endirə bilərsiniz'),
				'. ',
			];
		case 'el':
			return [
				getInfoTextBlock(
					MonetizationType.Flatrate,
					'Προς το παρόν μπορείτε να παρακολουθήσετε τον τίτλο',
					'με streaming στο'
				),
				getOfferTextBlock(MonetizationType.Ads, ' ή δωρεάν με διαφημίσεις στο'),
				'. ',
				getInfoTextBlock(
					MonetizationType.Buy,
					'Υπάρχει επίσης η δυνατότητα να αγοράσετε τον τίτλο',
					'ως αρχείο λήψης στο'
				),
				'. ',
			];
		case 'sr':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Trenutno možete da gledate', 'strim na'),
				getOfferTextBlock(MonetizationType.Ads, ' ili besplatno sa oglasima na'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Takođe je moguće kupiti', 'kao preuzimanje na'),
				'. ',
			];
		case 'sv':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'För närvarande kan du se', 'streama på'),
				getOfferTextBlock(MonetizationType.Ads, ' eller gratis med annonser på'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Det är också möjligt att köpa', 'som nedladdning på'),
				'. ',
			];
		case 'uk':
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Наразі ви можете дивитися трансляцію', 'на'),
				getOfferTextBlock(MonetizationType.Ads, ' aбо дивитися її безкоштовно з рекламою на'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'Ви також можете придбати і завантажити', 'на'),
				'. ',
			];
		case 'ur':
			return [
				getRTLInfoTextBlock(MonetizationType.Flatrate, 'فی الحال آپ', 'پر'),
				getOfferTextBlock(
					MonetizationType.Ads,
					' اسٹریمنگ دیکھنے کے قابل ہیں یا',
					'پر اشتہارات کے ساتھ مفت دیکھ سکتے ہیں۔'
				),
				' ',
				getInfoTextBlock(MonetizationType.Buy, 'یہ بھی ممکن ہے کہ', 'پر', 'کو ڈاؤن لوڈ کے طور پرخرید لیں۔'),
			];
		case 'zh':
			return [
				getRTLInfoTextBlock(MonetizationType.Flatrate, '目前你可以在', '观看', ','),
				getOfferTextBlock(MonetizationType.Ads, ' 或在', '免费带广告观看'),
				' ',
				getRTLInfoTextBlock(MonetizationType.Buy, '此外，还可以在', '上购买下载'),
			];
		case 'en':
		default:
			return [
				getInfoTextBlock(MonetizationType.Flatrate, 'Currently you are able to watch', 'streaming on'),
				getOfferTextBlock(MonetizationType.Ads, ' or for free with ads on'),
				'. ',
				getInfoTextBlock(MonetizationType.Buy, 'It is also possible to buy', 'as download on'),
				'. ',
			];
	}
});

return { __sfc: true,language, props, getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock, text }
}

})